export default __webpack_public_path__ + "static/media/attractions7.b971c9e0.png";